import { useContext } from 'react';
import { useQuery } from 'react-query';
import { rootKeys } from '../cache-keys/rootKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_request_api } from '@axo/shared/data-access/api';
import { loan_request } from '@axo/shared/data-access/types';

export function useRequestStatuses() {
  const { state } = useContext(DataAccessContext);
  const cacheKey = rootKeys.requestStatuses();
  const api = useAPI();

  return useQuery(cacheKey, loan_request_api.getRequestStatuses(api), {
    enabled: state.user.token.length > 0,
  });
}

export function useRequestStatusUtils() {
  const statuses = useRequestStatuses();

  const isInGroup = (
    status: loan_request.LoanRequestStatus | undefined,
    group: loan_request.RequestStatusGroup
  ) => {
    if (!statuses.data || !status) return false;
    try {
      const match = statuses.data[status];
      return match.Groups.includes(group);
    } catch (e) {
      console.error('Status not found', status);
      return false;
    }
  };

  return {
    isInRequestStatusGroup: isInGroup,
    fromCode(code: number) {
      const entries = Object.entries(statuses.data ?? {}) as [
        loan_request.LoanRequestStatus,
        loan_request.RequestStatuses[loan_request.LoanRequestStatus]
      ][];
      return entries
        .map(([Status, { Code }]) => ({ Status, Code }))
        .find(({ Code }) => code === Code)?.Status;
    },
  };
}
